import { get, del } from "./api";
import type { CrmMediaResponse } from "../types/crm";

export const getMediaForProfile = (profileId: string): Promise<CrmMediaResponse[]> =>
  get(`/api/crm/prospect-profiles/${profileId}/media`);

export const getMediaById = (mediaId: string): Promise<CrmMediaResponse> =>
  get(`/api/crm/media/${mediaId}`);

export const deleteMedia = (mediaId: string): Promise<void> =>
  del(`/api/crm/media/${mediaId}`);
